<template>
  <h1 class="visually-hidden">
    {{ replacedTitle }}
  </h1>
</template>

<script setup lang="ts">
import { replaceProjectName } from '@skeleton/utils/contentReplace';

const { getContent } = useProjectMethods();

const props = defineProps<{
  currentLocaleData?: any;
  defaultLocaleData?: any;
  contentPath: string;
}>();

const replacedTitle = computed(() => {
  return replaceProjectName(getContent(props.currentLocaleData, props.defaultLocaleData, props.contentPath));
});
</script>
